import { ROUTE } from "../../routes";
import sharedPropsService from "../../SharedPropsService";
import { partnerNavigate } from "../../configs/utils";
export const getStartedAction = async (action, _datastore, { navigate }) => {
    console.warn('**** getStartedAction Action Triggered ****', action);
    const user = await sharedPropsService.getUser();
    const referredPartner = action.payload.referredPartner;
    console.log("referred partner:  123", referredPartner);
    if (referredPartner) {
        await partnerNavigate(ROUTE.PARTNER_REFERRED_PARTNER);
    }
    else {
        await partnerNavigate(ROUTE.PARTNER_DASHBOARD_V2);
    }
};
